<template>
<div class="chapter">
<div class="inner_page">
<p class="pt" id="pt1"><span class="epub-b">PRELUDE</span></p>
<p class="v">All day, all day I brush</p>
<p class="v">My golden strands of hair;</p>
<p class="v">All day I wait and wait …</p>
<p class="vsb">Ah, who is there?</p>
<p class="v">Who calls? Who calls? The gold</p>
<p class="v">Ladder of my long hair</p>
<p class="v">I loose and wait … and wait …</p>
<p class="vsb">Ah, who is there?</p>
<p class="v">She left at dawn … I am blind</p>
<p class="v">In the tangle of my long hair …</p>
<p class="v">Is it she? the witch? the witch?</p>
<p class="vsb">Ah, who is there?</p>
<p class="linespace"> </p>
<p class="v">‘Rapunzel’</p>
<p class="v">Adelaide Crapsey</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?49a8e390